export const pagesDevicesCatalogEn = {
  catalog: {
    pageTitle: "Device Catalog",
    filterPlaceholder: "Search catalog",
    addCatalogItem: "Add Catalog",
    tabs: {
      ACTIVE: "Active",
      DRAFT: "Draft",
      ALL: "All",
      ARCHIVED: "Archived",
    },
  },
};
